/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Modal_TitleInputs */

const en_position_modal_title = /** @type {(inputs: Position_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set Position`)
};

const fr_position_modal_title = /** @type {(inputs: Position_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Definir la position`)
};

const de_position_modal_title = /** @type {(inputs: Position_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position einstellen`)
};

const it_position_modal_title = /** @type {(inputs: Position_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imposta posizione`)
};

const ru_position_modal_title = /** @type {(inputs: Position_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Установить позицию`)
};

const es_position_modal_title = /** @type {(inputs: Position_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Establecer posición`)
};

const zh_cn2_position_modal_title = /** @type {(inputs: Position_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设置位置`)
};

const ja_position_modal_title = /** @type {(inputs: Position_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`位置を設定する`)
};

const hi_position_modal_title = /** @type {(inputs: Position_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थिति निर्धारित करें`)
};

const pt_pt2_position_modal_title = /** @type {(inputs: Position_Modal_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posição definida`)
};

/**
* | output |
* | --- |
* | "Set Position" |
*
* @param {Position_Modal_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_modal_title = /** @type {((inputs?: Position_Modal_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Modal_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_position_modal_title(inputs)
	if (locale === "de") return de_position_modal_title(inputs)
	if (locale === "it") return it_position_modal_title(inputs)
	if (locale === "ru") return ru_position_modal_title(inputs)
	if (locale === "es") return es_position_modal_title(inputs)
	if (locale === "zh-CN") return zh_cn2_position_modal_title(inputs)
	if (locale === "ja") return ja_position_modal_title(inputs)
	if (locale === "hi") return hi_position_modal_title(inputs)
	if (locale === "pt-PT") return pt_pt2_position_modal_title(inputs)
	return en_position_modal_title(inputs)
});